/* GreenIT — tag each spec value with a class so CSS can colour it by value (V3.2) */
(function () {
  function handleize(s) {
    return (s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function paint() {
    var cells = document.querySelectorAll('.meta_data_grid .meta_data');
    for (var i = 0; i < cells.length; i++) {
      var v = cells[i].querySelector('span:last-child');
      if (!v || v.classList.contains('spec-pill')) continue;
      var key = handleize(v.textContent);
      if (key) v.classList.add('spec-pill', 'is-' + key);
    }
  }
  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
})();
